var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"Loader"},[_c('div',{staticClass:"Loader__bounce Loader__bounce--1"}),_c('div',{staticClass:"Loader__bounce Loader__bounce--2"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }